import {
  Difficulty3p,
  GameConfiguration,
  GameMode,
  PlayerCount,
} from './types';

export const DEFAULT_LA_FAMIGLIA_CONFIGURATION: GameConfiguration = {
  playerCount: 4,
  difficulty3p: 'medium',
  configured: false,
};

export type ConfigurationValidationResult = {
  valid: boolean;
  errors: string[];
};

export function playerCountToMode(playerCount: PlayerCount): GameMode {
  if (playerCount === 2) return '1vs1';
  if (playerCount === 3) return '2vs1';
  return '2vs2';
}

export function modeLabel(mode: GameMode): string {
  switch (mode) {
    case '1vs1':
      return '1vs1';
    case '2vs1':
      return '2vs1';
    case '2vs2':
      return '2vs2';
  }
}

export function modeLabelPl(mode: GameMode): string {
  switch (mode) {
    case '1vs1':
      return '1 na 1';
    case '2vs1':
      return '2 na 1';
    case '2vs2':
      return '2 na 2';
  }
}

export function difficultyLabelPl(difficulty: Difficulty3p): string {
  switch (difficulty) {
    case 'easy':
      return 'łatwy';
    case 'medium':
      return 'średni';
    case 'hard':
      return 'trudny';
  }
}

export function validateConfiguration(
  config: GameConfiguration
): ConfigurationValidationResult {
  const errors: string[] = [];
  if (config.playerCount !== 2 && config.playerCount !== 3 && config.playerCount !== 4) {
    errors.push('Liczba graczy musi wynosić 2, 3 lub 4.');
  }
  if (
    config.difficulty3p !== 'easy' &&
    config.difficulty3p !== 'medium' &&
    config.difficulty3p !== 'hard'
  ) {
    errors.push('Poziom trudności 3 graczy musi być: łatwy, średni lub trudny.');
  }
  return { valid: errors.length === 0, errors };
}

export function normalizeConfiguration(
  config: GameConfiguration
): GameConfiguration {
  const playerCount: PlayerCount =
    config.playerCount === 2 || config.playerCount === 3 || config.playerCount === 4
      ? config.playerCount
      : 4;
  const difficulty3p: Difficulty3p =
    config.difficulty3p === 'easy' ||
    config.difficulty3p === 'medium' ||
    config.difficulty3p === 'hard'
      ? config.difficulty3p
      : 'medium';
  return {
    playerCount,
    difficulty3p: playerCount === 3 ? difficulty3p : 'medium',
    configured: Boolean(config.configured),
  };
}

export function configurationSummary(config: GameConfiguration): string {
  const mode = modeLabel(playerCountToMode(config.playerCount));
  if (config.playerCount === 3) {
    return `${config.playerCount} graczy · ${mode} · ${difficultyLabelPl(config.difficulty3p)}`;
  }
  return `${config.playerCount} graczy · ${mode}`;
}

export function configurationWouldResetGuided(
  previous: GameConfiguration,
  next: GameConfiguration
): boolean {
  return (
    previous.playerCount !== next.playerCount ||
    (next.playerCount === 3 && previous.difficulty3p !== next.difficulty3p)
  );
}

export function isVisibleForPlayerCount(
  players: PlayerCount[] | undefined,
  playerCount: PlayerCount
): boolean {
  if (!players || players.length === 0) return true;
  return players.includes(playerCount);
}
